import React from "react";
import style from "./SidePanel.scss";
import overrides from "../../../../css/customization.scss";
import { changeSecondsToString } from "../../../hooks/useCountdown";

const CardEvent = (props) => {
    const cards = props.events.filter(
        (event) =>
            event.type.name === "GELB" ||
            event.type.name === "ROT" ||
            event.type.name === "GELB ROT" ||
            event.type.name === "GRÜN"
    );
    let colorClasses = {
        GELB: style.GELB,
        GRÜN: style.GRÜN,
        ROT: style.ROT,
        "GELB ROT": style.GELBROT,
    };

    return (
        <>
            {cards.length > 0 ? (
                cards.map((card, index) => {
                    return (
                        <div
                            className={`${style.cardEntry} ${overrides["roboto-16-700"]}`}
                            key={index}
                        >
                            <div>
                                {" "}
                                {changeSecondsToString(
                                    "timeOfEvent",
                                    card.timestamp
                                )}{" "}
                                min | {card.quarterSelected}
                            </div>
                            <div
                                className={`${style.cardEntryCircle} ${
                                    colorClasses[card.type.name]
                                }`}
                            ></div>
                            {card?.suspensionTime ? (
                                <div>
                                    {card?.suspensionTime?.name?.split(
                                        " "
                                    )?.[0] + " min"}
                                </div>
                            ) : (
                                ""
                            )}

                            <div>
                                {card.playerSelected?.playerNumber}{" "}
                                {card.playerSelected?.playerName ||
                                    card.playerSelected?.contactName}
                            </div>
                        </div>
                    );
                })
            ) : (
                <div className={style.cardEntry}>No Karten</div>
            )}
        </>
    );
};

export default CardEvent;
